module.exports = __webpack_public_path__ + "static/media/pathfinding_front.82c79bd8.svg";